import { render, staticRenderFns } from "./report-zhuanbing.vue?vue&type=template&id=52e30187&scoped=true&"
import script from "./report-zhuanbing.vue?vue&type=script&lang=ts&"
export * from "./report-zhuanbing.vue?vue&type=script&lang=ts&"
import style0 from "./report-zhuanbing.vue?vue&type=style&index=0&id=52e30187&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e30187",
  null
  
)

export default component.exports